
<template>
  <main style="background-color: white;">
    <div class="col-12 col-sm-5  col-md-5 container-sm pdv-0">
      <div class="min-height-50" style=" background-color:#312972;" >
        <span class=""> <img src="@/assets/img/logo-pacifica/Logo.svg" /></span>
      </div>
    
    </div>
  
  <div class="col-12 col-sm-5 col-md-5 container-sm pdv-0">
    <component :is="currentStep" 
      @next="goToInvoiceStep"
      @prev="goToReceiptStep" 
      @invoice="goToInvoiceStep"
      @preview="goToInvoicePreviewStep" 
      @submission="goToInvoiceSubmission"
      
     />
    
  </div>
  
  </main>
</template>
<style>
  .text-black{
    color : black!important;

  }

  .box-language{
    padding: 0.4rem 0.4rem;
  }

  .pdv-0{
    padding-left: 0px!important;
    padding-right: 0px!important;
  }
  main {
  /* width: 40vw;  */
  margin: 0 auto; 
}
  
</style>




<script setup>
import { onMounted ,shallowRef } from "vue";
import { useStore } from "vuex";
import FormReceipt from "@/views/components/evrt/page-form/FormReceipt.vue";
import FormInvoice from '@/views/components/evrt/page-form/FormInvoice.vue';
import FormInvoicePreview from '@/views/components/evrt/page-form/FormInvoicePreview.vue';
import FormInvoiceSubmission from '@/views/components/evrt/page-form/FormInvoiceSubmission.vue';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();


//const currentStep = ref(FormReceipt);
const currentStep = shallowRef(FormReceipt);


const goToReceiptStep = () => {
  currentStep.value = FormReceipt;
};

const goToInvoiceStep = () => {
  currentStep.value = FormInvoice;
};

const goToInvoicePreviewStep = () => {
  currentStep.value = FormInvoicePreview;
};

const goToInvoiceSubmission = () => {
  currentStep.value = FormInvoiceSubmission;
};

languageStore.selectedLanguage


const store = useStore();



onMounted(() => {
  store.state.isAbsolute = true;

});

//language
</script>